import * as React from 'react';
import { registerComponent, useMatchMobile, withProgressiveHydration } from '@avensia/excite';
import { ArticleListing } from 'webapp/inspiration/article-listing';
import ArticleCarousel from 'webapp/inspiration//article-listing/ArticleCarousel';
import BaseContentList from 'webapp/components/BaseContentList';
import { isSvenssons } from 'webapp/theme';

function ArticleListBlock(
  props: NordicNest.Api.ArticleListBlockApiModel & {
    id?: string;
  },
) {
  const isMobile = useMatchMobile();

  return (
    <BaseContentList {...props}>
      {(isSvenssons && isMobile) || (!isSvenssons && isMobile && props.articeList.length > 3) ? (
        <ArticleCarousel id={props.id} articles={props.articeList} cardBackgroundColor={props.cardBackgroundColor} />
      ) : (
        <ArticleListing list={props.articeList} cardBackgroundColor={props.cardBackgroundColor} />
      )}
    </BaseContentList>
  );
}

export const RegisteredProductListBlock = registerComponent<NordicNest.Api.ArticleListBlockApiModel>(
  withProgressiveHydration(ArticleListBlock),
);
